import {RichBlockComponentProps} from './blockComponents.tsx';
import React from 'react';
import SimpleLink from '../SimpleLink.tsx';
import {Box} from '@mui/material';
import {getBestTranslatedValue} from '../../../lib/localeHelper.ts';
import {DocumentBlockData} from '../../../types/api.ts';
import {getBestTranslatedAsset} from '../../../services/api/AssetApi.ts';

export default function DocumentBlock({
    isPreview,
    data,
    locale,
    userLocales,
}: RichBlockComponentProps<DocumentBlockData>) {
    const {title, asset, trackingUrl, translations} = data;
    if (!asset) {
        return null;
    }

    const translatedAsset = getBestTranslatedAsset(asset, userLocales);
    const assetUrl = translatedAsset.url;
    if (!assetUrl) {
        return null;
    }

    const resolvedTitle = getBestTranslatedValue(
        translations ?? {},
        'title',
        title,
        locale,
        userLocales,
    );

    const resolvedTrackingUrl = getBestTranslatedValue(
        translations ?? {},
        'trackingUrl',
        trackingUrl,
        locale,
        userLocales,
    );

    const finalUrl = !isPreview ? resolvedTrackingUrl || assetUrl : assetUrl;

    return (
        <Box
            sx={{
                mx: -2,
            }}
        >
            <SimpleLink
                url={finalUrl}
                label={resolvedTitle || translatedAsset.name || 'Unnamed'}
                icon={'document'}
            />
        </Box>
    );
}
